/* La Caza Cali — cart drawer express checkout layout (4.2.1).
 * Shopify renders one element per wallet inside
 * <shopify-accelerated-checkout-cart>, asynchronously and again every time
 * the drawer re-renders. Keep two primary wallets visible (Apple Pay +
 * Shop Pay, or Google Pay + Shop Pay where Apple Pay isn't offered) and
 * put the rest behind a "More payment options" toggle. */
(function () {
  'use strict';
  function kind(el) {
    var t = el.tagName.toLowerCase();
    if (t.indexOf('apple') > -1) return 'apple';
    if (t.indexOf('shop-pay') > -1) return 'shop';
    if (t.indexOf('google') > -1) return 'google';
    return 'other';
  }
  function classify(wrap) {
    var ace = wrap.querySelector('shopify-accelerated-checkout-cart');
    var more = wrap.querySelector('[data-express-more]');
    if (!ace) return;
    var kids = Array.prototype.slice.call(ace.children);
    if (!kids.length) return;
    var kinds = kids.map(kind);
    var hasApple = kinds.indexOf('apple') > -1;
    var extras = 0;
    kids.forEach(function (el, i) {
      var k = kinds[i];
      el.classList.remove('lcx-apple', 'lcx-shop', 'lcx-extra');
      if (k === 'apple') el.classList.add('lcx-apple');
      else if (k === 'shop') el.classList.add('lcx-shop');
      else if (k === 'google' && !hasApple) el.classList.add('lcx-apple');
      else { el.classList.add('lcx-extra'); }
    });
    extras = Math.max(0, kids.length - 2);
    if (more) more.hidden = extras === 0;
    // Shopify lays the wallets out in its own fixed order (Shop Pay, then
    // Apple Pay on Apple devices, then PayPal / Google Pay) inside a
    // closed layout, so the CSS simply crops the block to the first two
    // rows until "More payment options" is tapped.
    wrap.classList.toggle('has-extras', extras > 0);
  }
  function scan() {
    document.querySelectorAll('[data-cart-express]').forEach(classify);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-express-more]');
    if (!btn) return;
    var wrap = btn.closest('[data-cart-express]');
    var open = !wrap.classList.contains('is-expanded');
    wrap.classList.toggle('is-expanded', open);
    btn.textContent = open ? 'Fewer payment options' : 'More payment options';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  if ('MutationObserver' in window) {
    new MutationObserver(function () { scan(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
